// Import dependencies
import React from 'react';
import PropTypes from 'prop-types';
import Expandable from '../../Expandable';

class FilterBar extends React.Component {
  render() {
    const { onChange, categories } = this.props;
    const mappedCategories = categories.map((cat) => ({
      ...cat,
      label: cat.title,
      value: cat.id,
    }));

    return (
      <div className="c-card-listing__filter">
        <label className="c-form-label" htmlFor="card-show-filter">Filter</label>
        <div className="c-filterbar__desktop-version">
          <Expandable
            label="Category"
            handleChange={onChange}
            name="card-show-filter"
            id="card-show-filter"
            index={1}
            key={1}
            cyop
            options={mappedCategories}
          />
        </div>
        <div className="u-hide@large">
          <Expandable
            label="Category"
            handleChange={onChange}
            name="card-show-filter-mobile"
            id="card-show-filter-mobile"
            index={1}
            key={1}
            options={mappedCategories}
          />
        </div>
      </div>
    );
  }
}

FilterBar.propTypes = {
  onChange: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.string,
  })).isRequired,
};

export default FilterBar;
